import { Controller } from "@hotwired/stimulus";
import { trackProofEvent } from "../proof_events.js";

export default class extends Controller {
  static targets = ["review", "reference", "approve", "error", "success", "manual", "controls", "start", "announcement"];

  connect() {
    this.controlsTarget.hidden = false;
    this.resetState();
  }

  resetState() {
    this.reviewTarget.hidden = true;
    this.referenceTarget.value = "CMD-A21";
    this.referenceTarget.removeAttribute("aria-invalid");
    this.approveTarget.hidden = false;
    this.errorTarget.hidden = true;
    this.successTarget.hidden = true;
    this.manualTarget.hidden = true;
    this.startTarget.hidden = false;
    this.announcementTarget.textContent = "";
    this.completed = false;
  }

  start() {
    this.resetState();
    this.reviewTarget.hidden = false;
    this.startTarget.hidden = true;
    this.referenceTarget.focus();
    trackProofEvent("demo_start", "integration");
  }

  approve() {
    if (this.referenceTarget.value.trim().toUpperCase() !== "CMD-A12") {
      this.errorTarget.hidden = false;
      this.referenceTarget.setAttribute("aria-invalid", "true");
      this.announcementTarget.textContent = this.errorTarget.textContent;
      this.referenceTarget.focus();
      return;
    }
    this.errorTarget.hidden = true;
    this.referenceTarget.removeAttribute("aria-invalid");
    this.reviewTarget.hidden = true;
    this.successTarget.hidden = false;
    this.announcementTarget.textContent = this.successTarget.textContent;
    this.startTarget.hidden = false;
    this.startTarget.focus();
    if (!this.completed) trackProofEvent("demo_complete", "integration");
    this.completed = true;
  }

  outage() {
    this.resetState();
    this.manualTarget.hidden = false;
    this.announcementTarget.textContent = this.manualTarget.textContent;
    trackProofEvent("demo_outage", "integration");
  }

  reset() {
    this.resetState();
    this.startTarget.focus();
  }
}
